module.exports = __webpack_public_path__ + "img/756.f23454d3.jpg";